import Cookies from 'js-cookie';

const app = {
	state: {
		sidebar: {
			opened: !+Cookies.get('sidebarStatus'),
		},
		language: Cookies.get('language') || 'zh',
		wordDialog: false,
		wordData: [],
	},
	mutations: {
		TOGGLE_SIDEBAR: state => {
			if (state.sidebar.opened) {
				Cookies.set('sidebarStatus', 1);
			} else {
				Cookies.set('sidebarStatus', 0);
			}
			state.sidebar.opened = !state.sidebar.opened;
		},
		SET_LANGUAGE: (state, language) => {
			state.language = language;
			Cookies.set('language', language);
		},
		SET_WORDDIALOG: (state, data) => {
			state.wordDialog = data;
		},
		SET_WORDDATA: (state, data) => {
			state.wordData = data;
		},
	},
	actions: {
		toggleSideBar: ({ commit }) => {
			commit('TOGGLE_SIDEBAR');
		},
		setLanguage({ commit }, language) {
			commit('SET_LANGUAGE', language);
		},
	},
};

export default app;
